import TabContent from "./TabContent";

const NonSDNTab = ({
  data,
  reload,
  currentPage,
  itemsPerPage,
  selectedTab,
  onViewFile,
  onDeleteFile,
}) => {
  return (
    <>
      {/* Common table content */}
      <TabContent
        data={data}
        reload={reload}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        selectedTab={selectedTab}
        onViewFile={onViewFile}
        onDeleteFile={onDeleteFile}
      />
    </>
  );
};

export default NonSDNTab;
